import React from 'react';

export const SetShowMissedPaymentModalContext = React.createContext(() => { console.log('doh'); });
